namespace GeniuzPOS.SalePromoCamp {
    export class PsPromoApDtColumns {
        static columnsKey = 'SalePromoCamp.PsPromoApDt';
    }
}
